import { useAppSelector } from "src/app/store/hooks";
import { selectResellerCustomersApiArgs } from "src/features/resellerCustomers/resellerCustomersSlice";
import { selectResellerCustomerEntity } from "src/features/resellerCustomers/resellerCustomersApi";
const useGetResellerCustomer = (resellerCustomerId) => {
    const args = useAppSelector(selectResellerCustomersApiArgs);
    const resellerCustomer = useAppSelector(state => selectResellerCustomerEntity(state, args, resellerCustomerId));
    return resellerCustomer;
};
export default useGetResellerCustomer;
